import { ActionKeys } from '~/actions/constants';
import { ActionTypes } from '~/actions/index';

export type LoginState = {
  readonly isLoading: boolean;
  readonly error: string;
  readonly message: string;
  // Unused for now vv
  readonly csrfToken: string;
  readonly isFetchingCSRF: boolean;
};

export const initialState: LoginState = {
  isLoading: false,
  error: '',
  message: '',
  csrfToken: '',
  isFetchingCSRF: false,
};

function loginReducer(state: LoginState = initialState, action: ActionTypes) {
  switch (action.type) {
    case ActionKeys.LOGIN_FETCH_CSRF:
      return {
        ...state,
        isFetchingCSRF: true,
      };
    case ActionKeys.LOGIN_FETCH_CSRF_SUCCESS:
      return {
        ...state,
        csrfToken: action.payload.csrfToken,
        isFetchingCSRF: false,
      };
    case ActionKeys.LOGIN_FETCH_CSRF_ERROR:
      return {
        ...state,
        error: action.payload.error,
        isFetchingCSRF: false,
      };
    case ActionKeys.VERIFY_2FA_START:
      return {
        ...state,
        error: '',
        message: '',
        isLoading: false,
      };
    case ActionKeys.LOGIN_SUBMIT:
    case ActionKeys.RESEND_2FA_SUBMIT:
    case ActionKeys.RESET_PASSWORD_SUBMIT:
    case ActionKeys.VERIFY_2FA_SUBMIT:
      return {
        ...state,
        error: '',
        message: '',
        isLoading: true,
      };
    case ActionKeys.RESEND_2FA_SUCCESS:
      return {
        ...state,
        error: '',
        message: action.payload.successMessage,
        isLoading: false,
      };
    case ActionKeys.LOGIN_SUCCESS:
    case ActionKeys.RESET_PASSWORD_SUCCESS:
    case ActionKeys.VERIFY_2FA_SUCCESS:
      return {
        ...state,
        error: '',
        message: '',
        isLoading: false,
      };
    case ActionKeys.LOGIN_ERROR:
    case ActionKeys.RESEND_2FA_ERROR:
    case ActionKeys.RESET_PASSWORD_ERROR:
    case ActionKeys.VERIFY_2FA_ERROR:
      return {
        ...state,
        error: action.payload.error,
        isLoading: false,
      };
    default:
      return state;
  }
}

export default loginReducer;
